/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { mdmsService } from "../../services/mdmsService";
import _ from "lodash";
import { setAccessToken } from "../../services/commerceServices/accessToken";
// import { cartMergingCall } from "../../services/commerceServices/cartServices";
import Loader from "../shared-ui/loader";
import { Login } from "../../core/authentication";
import Button from "../shared-ui/button";
import AdminPopupComponent from "../shared-ui/popup/admin-popup";
/**
 * Login Successful component
 *
 * @namespace LoginSuccessful
 */
const AdminLogin = () => {
  const history = useHistory();
  const { authState, oktaAuth } = useOktaAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [isPopupShow, setIsPopupShow] = useState(false);
  /**
   * This method is used for handle moved to the same page after successful login
   *
   */

  //  useEffect((): any => {
  //   // This method returns the previous page.
  //   history.go(-2);
  //   // This method is called mdms service to get user info
  //   if (authState && authState.isAuthenticated) {
  //     //mdmsService();
  //     //handleUserInfo();// TODO: Need info from mdms service
  //   }
  // });
  useEffect((): any => {
    // Calling mdms service based on login / logout condition
    let tokenStorage = sessionStorage.getItem("okta-token-storage");
    let isAdminSessionExpired = sessionStorage.getItem("isAdminSessionExpired");
    if (!isAdminSessionExpired) {
      Login(oktaAuth);
    }
    if (isAdminSessionExpired) {
      setIsPopupShow(true);
    }
  });

  const handleSignOut = () => {
    oktaAuth.signOut({
      postLogoutRedirectUri: `${window.location.origin}/admin`,
    });
  };

  const handleClose = () => {
    setIsPopupShow(false);
  };
  const handleLogin = () => {
    setIsPopupShow(false);
    sessionStorage.removeItem("isAdminSessionExpired");
    Login(oktaAuth);
  };

  // const handleSignIn = () => {
  //   let tokenStorage = sessionStorage.getItem("okta-token-storage");
  //   if(!tokenStorage) {
  //   Login(oktaAuth);
  //   }
  // }

  return (
    <div>
      {/* <h1>Admin comming soon!!!</h1> */}
      {/* <Button onButtonClick={()=>handleSignIn()} name={"Login"} className={"app-btn"}></Button> */}
      <AdminPopupComponent
        open={isPopupShow}
        close={handleClose}
        onDelete={handleLogin}
        buttonName={"sessionExpired"}
        cancleButtonName={"Ok"}
        heading={"Session Expired"}
        title={
          "Since you've been gone a while, we logged you out of the Wellness Admin Tool. Log back in to get going!"
        }
      />
    </div>
  );
};

export default AdminLogin;
